export function roundNumber(a: number): number {
  if (a > 0) {
    return Math.round(a * 100) / 100;
  }
  return 0;
}
